// Polyfilly pro kompatibilitu s Edge(EdgeHTML)
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import "fast-text-encoding/text";
// React
import React, { Suspense } from "react";
import ReactDOM from "react-dom";
// Redux
import { Provider } from "react-redux";
// Router
import { ConnectedRouter } from "connected-react-router";
// Redux persist
import { PersistGate } from 'redux-persist/integration/react'
// Store and router history
import { store, history, persistor } from "./infrastructure/store/ConfigureStore";
// Localization
import "infrastructure/localization/i18n";
// IoC Container
import "reflect-metadata"; // Import only once
import { inversifyContainer } from "./infrastructure/ioc/ioc.container";
import { InversifyProvider } from "./infrastructure/ioc/ioc.react";
// Logging
import * as log from "loglevel";
//import remote from "loglevel-plugin-remote";
// OIDC
import { OidcProvider } from "redux-oidc";
import UserManager from "./infrastructure/oidc/UserManager";
// Others
import * as serviceWorker from "./serviceWorker";
import App from "./App";
import "react-dates/initialize"; // Aby fungovaly styly na datepicker
import LoadingSpinner from "features/shared/components/loaders/LoadingSpinner";

// Config
// Log
log.setDefaultLevel(log.levels.DEBUG);

ReactDOM.render(
  <Provider store={store}>
    <OidcProvider store={store} userManager={UserManager}>
      <ConnectedRouter history={history}>
        <PersistGate loading={<LoadingSpinner />} persistor={persistor}>
          <InversifyProvider container={inversifyContainer}>
            <React.StrictMode>
              <Suspense fallback={<LoadingSpinner />}>
                <App />
              </Suspense>
            </React.StrictMode>
          </InversifyProvider>
        </PersistGate>
      </ConnectedRouter>
    </OidcProvider>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
